import React from "react";
import { Link }  from "react-router-dom";


function Hqskip() {
  return (

    <div className="hqslide_box">
       <Link to="/Landing" >skip</Link>
    </div>

    );
}

export default Hqskip;
